export const signUp = `mutation CustomerRegister($phoneNumber: String!) {
  customerRegister(phoneNumber: $phoneNumber) {
    _id
    name
    phone
    customerType
    isActive
    jwtToken
    refreshToken
    addresses {
      _id
      location {
        coordinates
      }
      deliveryAddress
      details
      label
      selected
      isActive
    }
    status
    permittedPaymentOptions {
      method
      label
    }
    selectedPaymentMethod
    cart {
      items {
        productId
        skuId
        name
        description
        image
        quantity
        mrp
        prices {
          customerType
          sellingPrice
        }
        status
      }
      deliveryAddress {
        _id
        deliveryAddress
        details
        label
        selected
        isActive
      }
      billDetails {
        itemsTotal
        deliveryCharge
        couponDiscount
        grandTotal
        totalSaving
        handlingCharge
        itemSavings
        itemsMrp
      }
    }
  }
}`;

export const signIn = `
mutation CustomerVerifyOTP($phoneNumber: String!, $otp: String!, $longitude: String!, $latitude: String!) {
  customerVerifyOTP(phoneNumber: $phoneNumber, otp: $otp, longitude: $longitude, latitude: $latitude) {
    _id
    name
    phone
    email
    gender
    nativePlace
    customerType
    isActive
    jwtToken
    refreshToken
    addresses {
      _id
      location {
        coordinates
      }
      deliveryAddress
      details
      label
      selected
      isActive
    }
    status
    permittedPaymentOptions {
      method
      label
    }
    selectedPaymentMethod
    cart {
      items {
        productId
        skuId
        name
        description
        image
        quantity
        mrp
        prices {
          customerType
          sellingPrice
        }
        status
      }
      deliveryAddress {
        _id
        deliveryAddress
        details
        label
        selected
        isActive
      }
      billDetails {
        itemsTotal
        deliveryCharge
        couponDiscount
        grandTotal
        totalSaving
        handlingCharge
        itemSavings
        itemsMrp
        chargesWaived
      }
    }
    GST
    canApplyReferral
  }
}`;

export const applyReferrals = `
mutation ApplyReferrals($code: String!, $longitude: String!, $latitude: String!) {
  applyReferrals(code: $code, longitude: $longitude, latitude: $latitude)
}
`;

export const SetDeliverySlotForOrder = `
mutation SetDeliverySlotForOrder($slotId: String, $date: String) {
  setDeliverySlotForOrder(slotId: $slotId, date: $date)
}
`;

export const addItemsToCart = `
mutation AddItemsToCart($cartAddInputs: CartAddInputs!) {
  addItemsToCart(cartAddInputs: $cartAddInputs) {
    productId
    skuId
    quantity
    status
  }
}
`;

export const AddItemsForReorder = `
mutation AddItemsForReorder($orderId: String) {
  addItemsForReorder(orderId: $orderId) {
    productId
    skuId
    quantity
    status
  }
}
`;

export const removeItemsToCart = `
mutation RemoveItemFromCart($item: ItemInput!) {
  removeItemFromCart(item: $item)
}
`;

export const placeOrder = `mutation PlaceOrderV2($paymentMethod: Int!, $itemsTotal: Int!, $grandTotal: Float!) {
  placeOrderV2(paymentMethod: $paymentMethod, itemsTotal: $itemsTotal, grandTotal: $grandTotal) {
    _id
    items {
      productId
      skuId
      name
      description
      image
      quantity
      mrp
      sellingPrice
      prices {
        customerType
        sellingPrice
      }
      status
      measure
      unit
      packingChecked
      billingChecked
      oldSp
      oldCost
    }
    customerId
    customerType
    paymentStatus
    paymentMethod
    orderStatus
    paidAmount
    orderAmount
    orderDate
    deliveryDate
    billDetails {
      itemsTotal
      deliveryCharge
      grandTotal
      totalSaving
      handlingCharge
      itemSavings
      itemsMrp
      chargesWaived
      couponDiscount
      referralInfo {
        applied
        amount
        code
        message
        referrerId
        percentage
      }
      walletInfo {
        applied
        amount
        message
      }
      couponInfo {
        applied
        amount
        code
        message
        cancellationApplied
        limitRate
        daysRange
      }
      nestInfo {
        applied
        amount
        message
        couponRefundAmount
        couponRefundAccomodated
      }
      cancelledInfo {
        nestInfo {
          applied
          amount
          message
          couponCancellationAmount
          couponCancellationAccomodated
        }
      }
      refund
      premiumCustomerSaving
    }
    deliveryAddress {
      _id
      location {
        coordinates
      }
      deliveryAddress
      details
      label
      selected
      isActive
    }
    onlinePaymentStatus
    refundStatus
    isOrderModified
    deliveredImage
  }
}`;

export const logOut = `
mutation Mutation {
  logoutCustomer
}
`;

export const AddCustomerAddress = `
mutation AddCustomerAddress($addressInput: AddressInput!) {
  addCustomerAddress(addressInput: $addressInput) {
    address {
      _id
      location {
        coordinates
      }
      deliveryAddress
      details
      label
      selected
      isActive
    }
    status
  }
}
`;

export const SelectCustomerAddress = `mutation SelectCustomerAddress($addressId: String!) {
  selectCustomerAddress(addressId: $addressId) {
    _id
    name
    phone
    customerType
    isActive
    jwtToken
    refreshToken
    addresses {
      _id
      location {
        coordinates
      }
      deliveryAddress
      details
      label
      selected
      isActive
    }
    status
    permittedPaymentOptions {
      method
      label
    }
    selectedPaymentMethod
    cart {
      items {
        productId
        skuId
        name
        description
        image
        quantity
        mrp
        prices {
          customerType
          sellingPrice
        }
        status
      }
      deliveryAddress {
        _id
        deliveryAddress
        details
        label
        selected
        isActive
      }
      billDetails {
        itemsTotal
        deliveryCharge
        couponDiscount
        grandTotal
        totalSaving
        handlingCharge
        itemSavings
        itemsMrp
      }
    }
  }
}`;

export const UpatePushNotificationToken =`
mutation UpatePushNotificationToken($token: String!) {
  upatePushNotificationToken(token: $token)
}
`


export const UpdateCustomerName = `mutation UpdateCustomerName($name: String!, $phone: String, $gst: String, $email: String, $gender: String, $nativePlace: String) {
  updateCustomerName(name: $name, phone: $phone, gst: $gst, email: $email, gender: $gender, nativePlace: $nativePlace) {
    _id
    name
    phone
    email
    gender
    nativePlace
    customerType
    isActive
    jwtToken
    refreshToken
    addresses {
      _id
      location {
        coordinates
      }
      deliveryAddress
      details
      label
      selected
      isActive
    }
    status
    permittedPaymentOptions {
      method
      label
    }
    selectedPaymentMethod
    cart {
      items {
        productId
        skuId
        name
        description
        image
        quantity
        mrp
        prices {
          customerType
          sellingPrice
        }
        status
      }
      deliveryAddress {
        _id
        deliveryAddress
        details
        label
        selected
        isActive
      }
      billDetails {
        itemsTotal
        deliveryCharge
        couponDiscount
        grandTotal
        totalSaving
        handlingCharge
        itemSavings
        itemsMrp
        chargesWaived
      }
    }
    GST
  }
}`

export const UpdateAddressDetails = `mutation UpdateAddressDetails($addressDetails: AddressDetails!, $addressId: String) {
  updateAddressDetails(addressDetails: $addressDetails, addressId: $addressId) {
    _id
    location {
      coordinates
    }
    deliveryAddress
    details
    label
    selected
    isActive
  }
}`

export const SendCustomerSupportEmail = `mutation SendCustomerSupportEmail($name: String!, $phone: String!, $email: String!, $reason: String!, $subject: String!) {
  sendCustomerSupportEmail(name: $name, phone: $phone, email: $email, reason: $reason, subject: $subject)
}`

export const CancelOrder = `mutation CancelOrder($orderId: String) {
  cancelOrder(orderId: $orderId) {
    orderId
    refundStatus
    refundAmount
    refunxTxnId
    message
    orderStatus
  }
}`

export const ChangePaymentToCODForOrder = `mutation ChangePaymentToCODForOrder($orderId: String) {
  changePaymentToCODForOrder(orderId: $orderId) {
    order {
      _id
      items {
        productId
        skuId
        name
        description
        image
        quantity
        mrp
        prices {
          customerType
          sellingPrice
        }
        status
      }
      customerId
      paymentStatus
      paymentMethod
      orderStatus
      paidAmount
      orderAmount
      orderDate
      deliveryDate
      billDetails {
        itemsTotal
        deliveryCharge
        couponDiscount
        grandTotal
        totalSaving
        handlingCharge
        itemSavings
        itemsMrp
      }
      deliveryAddress {
        _id
        location {
          coordinates
        }
        deliveryAddress
        details
        label
        selected
        isActive
      }
      onlinePaymentStatus
      refundStatus
      isOrderModified
    }
    message
  }
}`

export const ApplyCoupon = `mutation ApplyCoupon($code: String) {
  applyCoupon(code: $code) {
    itemsTotal
    deliveryCharge
    grandTotal
    totalSaving
    handlingCharge
    itemSavings
    itemsMrp
    chargesWaived
    couponDiscount
    walletInfo {
      applied
      amount
      message
    }
    couponInfo {
      applied
      amount
      code
      message
      cancellationApplied
    }
    nestInfo {
      applied
      amount
      message
      couponRefundAmount
      couponRefundAccomodated
    }
    cancelledInfo {
      nestInfo {
        applied
        amount
        message
        couponCancellationAmount
        couponCancellationAccomodated
      }
    }
  }
}`

export const RemoveCoupon = `mutation RemoveAppliedCoupon {
  removeAppliedCoupon {
    itemsTotal
    deliveryCharge
    grandTotal
    totalSaving
    handlingCharge
    itemSavings
    itemsMrp
    chargesWaived
    couponDiscount
    walletInfo {
      applied
      amount
      message
    }
    couponInfo {
      applied
      amount
      code
      message
      cancellationApplied
    }
    nestInfo {
      applied
      amount
      message
      couponRefundAmount
      couponRefundAccomodated
    }
    cancelledInfo {
      nestInfo {
        applied
        amount
        message
        couponCancellationAmount
        couponCancellationAccomodated
      }
    }
  }
}`


export const UpdateOnlineTransactionParameters = `mutation UpdateOnlineTransactionParameters($orderId: String) {
  updateOnlineTransactionParameters(orderId: $orderId) {
    merchantId
    body
    checksum
  }
}`

export const AddFavourites = `mutation AddFavourites($productId: String!) {
  addFavourites(productId: $productId) {
    _id
    name
    phone
    email
    gender
    nativePlace
    customerType
    isActive
    jwtToken
    refreshToken
    addresses {
      _id
      location {
        coordinates
      }
      deliveryAddress
      details
      label
      selected
      isActive
    }
    status
    permittedPaymentOptions {
      method
      label
    }
    selectedPaymentMethod
    cart {
      items {
        productId
        skuId
        name
        description
        image
        quantity
        mrp
        prices {
          customerType
          sellingPrice
        }
        status
        packingChecked
        billingChecked
      }
      deliveryAddress {
        _id
        deliveryAddress
        details
        label
        selected
        isActive
      }
      billDetails {
        itemsTotal
        deliveryCharge
        grandTotal
        totalSaving
        handlingCharge
        itemSavings
        itemsMrp
        chargesWaived
        couponDiscount
        walletInfo {
          applied
          amount
          message
        }
        couponInfo {
          applied
          amount
          code
          message
          cancellationApplied
        }
        nestInfo {
          applied
          amount
          message
          couponRefundAmount
          couponRefundAccomodated
        }
        cancelledInfo {
          nestInfo {
            applied
            amount
            message
            couponCancellationAmount
            couponCancellationAccomodated
          }
        }
      }
    }
    GST
    onlinePaymentProvider
    favourites
  }
}`

export const RemoveFavourites = `mutation RemoveFavourites($productId: String!) {
  removeFavourites(productId: $productId) {
    _id
    name
    phone
    email
    gender
    nativePlace
    customerType
    isActive
    jwtToken
    refreshToken
    addresses {
      _id
      location {
        coordinates
      }
      deliveryAddress
      details
      label
      selected
      isActive
    }
    status
    permittedPaymentOptions {
      method
      label
    }
    selectedPaymentMethod
    cart {
      items {
        productId
        skuId
        name
        description
        image
        quantity
        mrp
        prices {
          customerType
          sellingPrice
        }
        status
        packingChecked
        billingChecked
      }
      deliveryAddress {
        _id
        deliveryAddress
        details
        label
        selected
        isActive
      }
      billDetails {
        itemsTotal
        deliveryCharge
        grandTotal
        totalSaving
        handlingCharge
        itemSavings
        itemsMrp
        chargesWaived
        couponDiscount
        walletInfo {
          applied
          amount
          message
        }
        couponInfo {
          applied
          amount
          code
          message
          cancellationApplied
        }
        nestInfo {
          applied
          amount
          message
          couponRefundAmount
          couponRefundAccomodated
        }
        cancelledInfo {
          nestInfo {
            applied
            amount
            message
            couponCancellationAmount
            couponCancellationAccomodated
          }
        }
      }
    }
    GST
    onlinePaymentProvider
    favourites
  }
}`
export const PurchaseNestPass = `mutation PurchaseNestPass {
  purchaseNestPass {
    merchantId
    body
    checksum
    message
  }
}`

export const NestPassPurchase =  `mutation Mutation {
  generateNestPassHashCode
}`